export const Wordmark = ({ className = "" }) => (
  <span
    data-testid="brand-wordmark"
    className={`font-display font-900 uppercase leading-none tracking-tight ${className}`}
  >
    <span className="text-white">FASTLANE</span>
    <span className="text-[var(--blue-bright)]"> MOTORZ</span>
  </span>
);
